import type { WorksheetExportType } from './type'

/** 홈룸 권한과 무관하게 학원 전체 학생을 허용하는 시험 export 타입 */
const ALL_STUDENT_EXPORT_TYPES = new Set<WorksheetExportType>([
  'KMM',
  'KMM_PRACTICE_TEST',
  'WEIZMANN',
])

export const isAllStudentExportType = (type?: WorksheetExportType): boolean =>
  type !== undefined && ALL_STUDENT_EXPORT_TYPES.has(type)
